export default {
  fa: {
    currencyFormat: {
      style: 'currency' as const,
      currency: 'RIAL',
    },
  },
}
